

export const logoGeneration = {
    toolName: 'Logo生成器',
    toolDescription: '使用AI技術生成專業的Logo設計，只需輸入描述即可創建獨特的品牌標識',
    promptTemplate: '請為我設計一個現代簡約風格的Logo，包含以下元素：',
    
    // 提示词输入相关
    promptLabel: 'Logo描述',
    promptDescription: '描述您想要創建的Logo',
    promptPlaceholder: '請輸入您的Logo描述...',
    
    // 提示词建议
    promptSuggestions: {
      title: '提示詞建議',
      business: '商業Logo：現代簡約的科技公司Logo，藍色調，包含字母"T"',
      creative: '創意Logo：藝術工作室Logo，彩色筆刷效果，創意字體',
      minimal: '極簡Logo：極簡主義咖啡店Logo，棕色調，咖啡豆元素',
      tech: '科技Logo：AI科技公司Logo，未來感設計，藍綠漸變'
    },
    
    // 生成参数
    parameters: {
      style: '風格',
      colors: '顏色',
      elements: '元素',
      modern: '現代',
      classic: '經典',
      minimal: '極簡',
      creative: '創意'
    },
    
    // 结果相关
    results: {
      title: 'Logo生成結果',
      downloading: '正在下載Logo...',
      downloadSuccess: 'Logo下載成功！',
      downloadFailed: 'Logo下載失敗，請重試',
      regenerating: '正在重新生成...',
      saveToCollection: '保存到收藏'
    },
    
    // 错误消息
    errors: {
      emptyPrompt: '請輸入Logo描述',
      generationFailed: 'Logo生成失敗，請重試',
      networkError: '網路錯誤，請檢查連接',
      serverError: '伺服器錯誤，請稍後重試'
    }
  };
